import { Injectable } from '@angular/core';

import type { VideoParser } from '@core/prosemirror-legacy';

export const YT_VIDEO_ID_PATTERN =
  /(?:https?:\/\/)?(?:[\w-]+\.)?(?:youtube\.[\w.]+\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

@Injectable()
export class VideoParserService implements VideoParser {
  private VIMEO_VIDEO_ID_PATTERN = /^.*(?:vimeo.com\/|video\/)([^#&?]*).*/;
  private YT_ID_PATTERN = /^[a-zA-Z0-9_-]{11}$/;
  private VIMEO_ID_PATTERN = /^[0-9]{8,14}(\/[0-9a-z]{8,14})?$/;

  public parse(src: string): string {
    if (!src || src.length === 0) return '';
    if (this.isYouTubeSource(src)) return this.parseYouTubeSource(src);
    if (this.isVimeoSource(src)) return this.parseVimeoSource(src);
    return '';
  }

  private getYouTubeEmbedUrl = (videoId: string) => `//www.youtube.com/embed/${videoId}`;
  private getVimeoEmbedUrl = (videoId: string) => `//player.vimeo.com/video/${videoId}`;
  private isVimeoSource = (src: string) => src.match(/vimeo/);
  private isYouTubeSource = (src: string) => src.match(/youtu/);

  private parseYouTubeSource(src: string): string {
    const match = src.match(YT_VIDEO_ID_PATTERN);
    const videoId = match?.[1];

    if (videoId && this.validateYouTubeId(videoId)) {
      return this.getYouTubeEmbedUrl(videoId);
    }

    return '';
  }

  private parseVimeoSource(src: string): string {
    const match = src.match(this.VIMEO_VIDEO_ID_PATTERN);
    const videoIdUrl = match?.[1];

    if (videoIdUrl && this.validateVimeoId(videoIdUrl)) {
      const videoId = videoIdUrl.split('/')[0];
      return this.getVimeoEmbedUrl(videoId);
    }

    return '';
  }

  private validateYouTubeId(videoId: string): boolean {
    return this.YT_ID_PATTERN.test(videoId);
  }

  private validateVimeoId(videoId: string): boolean {
    return this.VIMEO_ID_PATTERN.test(videoId);
  }
}
